import getEmployeeCompensationData from './getEmployeeCompensationData';

export default { getEmployeeCompensationData };
